import { GlButton, GlFormCheckbox, GlKeysetPagination, GlSprintf } from '@gitlab/ui';
import { __, n__ } from '~/locale';
export default {
    name: 'RegistryList',
    components: {
        GlButton,
        GlFormCheckbox,
        GlKeysetPagination,
        GlSprintf
    },
    props: {
        hiddenDelete: {
            type: Boolean,
            default: false,
            required: false
        },
        pagination: {
            type: Object,
            required: false,
            default: ()=>({})
        },
        items: {
            type: Array,
            required: false,
            default: ()=>[]
        },
        unSelectableItemIds: {
            type: Array,
            required: false,
            default: ()=>[]
        },
        idProperty: {
            type: String,
            required: false,
            default: 'id'
        }
    },
    emits: [
        'delete',
        'next-page',
        'prev-page'
    ],
    data () {
        return {
            selectedReferences: {}
        };
    },
    computed: {
        containsSelectedItems () {
            return this.selectedItems.length > 0;
        },
        selectableItems () {
            if (this.unSelectableItemIds.length === 0) {
                return this.items;
            }
            return this.items.filter((item)=>!this.unSelectableItemIds.includes(this.getItemId(item)));
        },
        selectedItems () {
            return this.items.filter(this.isSelected);
        },
        selectableItemIds () {
            return this.selectableItems.map((item)=>item[this.idProperty]);
        },
        disabled () {
            return this.selectableItems.length === 0;
        },
        checked () {
            return !this.disabled && this.selectableItems.every(this.isSelected);
        },
        indeterminate () {
            return !this.checked && this.items.some(this.isSelected);
        },
        selectAllLabel () {
            return this.checked ? __('Clear all') : __('Select all');
        },
        selectedCountMessage () {
            return n__('PackageRegistry|%{count} selected', 'PackageRegistry|%{count} selected', this.selectedItems.length);
        }
    },
    methods: {
        handleSelectAllChange (event) {
            this.selectableItems.forEach((item)=>{
                const id = this.getItemId(item);
                this.selectedReferences = {
                    ...this.selectedReferences,
                    [id]: event
                };
            });
        },
        getItemId (item) {
            return item[this.idProperty];
        },
        selectItem (item) {
            const id = this.getItemId(item);
            this.selectedReferences = {
                ...this.selectedReferences,
                [id]: !this.selectedReferences[id]
            };
        },
        isSelected (item) {
            const id = this.getItemId(item);
            return this.selectedReferences[id];
        },
        isSelectable (item) {
            return this.selectableItemIds.includes(this.getItemId(item));
        }
    },
    i18n: {
        deleteSelected: __('Delete selected')
    }
};
